import wrapWithState from "src/shared/utilities/state/apollo/wrapWithState";

import entry from "../constants/feature";
import reducer from "./reducer";

export const apolloWrapper = wrapWithState({
  feature: entry,
  reducer
});
